import qs from 'qs'
import axios from '@/api/apiClient'

/**
 * ram子账号管理api（ResourceAccessManagement）
 */
const api = {
  addQuickly: '/api/member/myinfo/sub/add',
  addManual: '/api/member/myinfo/sub/addmanual',
  addManualVerifycode: '/api/member/myinfo/sub/addmanual/verifycode',
  accountListDetail: '/api/member/myinfo/sub/detail',
  accountStatus: '/api/member/myinfo/sub/lock',
  accountReplacePassword: '/api/member/myinfo/sub/resetpass',
  // 客户
  CustomerList: '/api/myMemberCloudSystemBinding/page',
  CustomerListDetail: '/api/myMemberCloudSystemBinding/detail',
  CustomerBindingList: '/api/myMemberCloudSystemBinding/binding/history/page',
  CustomerBinding: '/api/myMemberCloudSystemBinding/bindIng',
  CustomerBindingSelectList: '/api/member/myinfo/sub/allList',
  CustomerUnbind: '/api/myMemberCloudSystemBinding/unBindIng',
}
export default api
/**
 * 绑定
 * @param {*} param.bindingId 绑定id
 * @param {*} param.memberCode 主账号or子账号用户code
 */
export const postCustomerBinding = (param) => {
  return axios.$post(`${api.CustomerBinding}`, param)
}
/**
 * 解绑
 * @param {*} param.bindingId 绑定id
 */
export const postCustomerUnbind = (param) => {
  return axios.$post(`${api.CustomerUnbind}`, param)
}
/**
 * 账号列表(主账号+所有子账号)
 * @param {*} query.current
 * @param {*} query.size
 */
export const getCustomerBindingSelectList = (query) => {
  return axios.$get(`${api.CustomerBindingSelectList}${query ? `?${qs.stringify(query)}` : ''}`)
}
/**
 * 客户绑定记录
 * @param {*} id
 * @param {*} query.current
 * @param {*} query.size
 */
export const getCustomerBindingList = (id, query) => {
  return axios.$get(`${api.CustomerBindingList}/${id}${query ? `?${qs.stringify(query)}` : ''}`)
}
/**
 * 获取客户列表详情
 * @param {*} bindingId
 */
export const getCustomerListDetail = (id) => {
  return axios.$get(`${api.CustomerListDetail}/${id}`)
}
/**
 * 获取客户列表
 * @param {*} query.current
 * @param {*} query.size
 * @param {*} query.memberCode 子账号code子账号绑定列表传入；主账号客户列表子账号搜索字段
 * @param {*} query.parentMemberCode 主账号code我的客户列表传入
 * @param {*} query.companyName 公司名称
 * @param {*} query.status 不传则是全部；1绑定； -1未绑定
 */
export const getCustomerList = (query) => {
  return axios.$get(`${api.CustomerList}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 一键添加子账户
 */
export const postAccountQuickly = () => {
  return axios.$post(`${api.addQuickly}`)
}
/**
 * 手动添加子账户
 * @param {*} loginName 手机号或邮箱(url中)
 * @param {*} query.verifyCode 验证码
 */
export const putAccountManual = (loginName, query) => {
  return axios.$put(`${api.addManual}/${loginName}${query ? `?${qs.stringify(query)}` : ''}`)
}
/**
 * 手动添加子账户-发送验证码
 * @param {*} loginName 手机号或邮箱(url中)
 */
export const getAccountManualVerifyCode = (loginName) => {
  return axios.$get(`${api.addManualVerifycode}/${loginName}`)
}
/**
 * 获取子账户列表
 * @param {*} id 会员id
 * @param {*} query.
 */
export const getAccountList = (query) => {
  return axios.$get(`/api/member/myinfo/sub/list/v2${query ? `?${qs.stringify(query)}` : ''}`)
}
/**
 * 获取子账户详情
 * @param {String} memberCode 会员id
 */
export const getAccountListDetail = (memberCode) => {
  return axios.$get(`${api.accountListDetail}/${memberCode}`)
}
/**
 * 子账户禁用、启用
 * @param {*} memunicode 子账户用户code
 */
export const putAccountStatusToggle = (memunicode) => {
  return axios.$put(`${api.accountStatus}/${memunicode}`)
}
/**
 * 重置子账号密码
 * @param {*} memunicode 子账户用户code
 * @param {*} query.newPassword 新密码
 */
export const putAccountReplacePassword = (memunicode, query) => {
  return axios.$put(`${api.accountReplacePassword}/${memunicode}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * @description: 子账号管理侧边信息（企业子账号数、子账号已获客数）
 * @param {*}
 * @return {*} subAccountNum 子账号总数
 * @return {*} subAccountOutLimit 子账号数量是否超过套餐上限 true:超过（限制立即邀请按钮跳转）、false:未超过
 * @return {*} bindingClientNum 子账号绑定客户总数
 */
export const getSubInfo = (query) => {
  return axios.$get(`/api/company/myinfo/sub/info${query ? `?${qs.stringify(query)}` : ''}`)
}

// 子账号申请审核列表
export const getRamReviewTableData = (query) => {
  return axios.$get(`/api/member/myJoin/audit/page${query ? `?${qs.stringify(query)}` : ''}`)
}

// 未审核的子账号申请数量
export const getRamNotReviewedNumberApplications = () => {
  return axios.$get('/api/member/myinfo/unOps/num')
}

// 通过子账号申请审核
export const applicationReviewThroughRam = (applyIdList) => {
  return axios.$put('/api/member/myJoin/audit/agree', { applyIdList })
}

// 拒绝子账号申请审核
export const rejectRamApplicationAudit = (applyIdList) => {
  return axios.$put('/api/member/myJoin/audit/refuse', { applyIdList })
}

/**
 * 主账号操作子账号的离职交接
 * @param {*} loginName 子账号用户名
 * @param {*} phone 手机号
 * @param {*} password 密码
 * @returns
 */
export const postMasterSetSubResignation = (param) => {
  return axios.$post('/api/member/myinfo/parent/handover', param)
}
